<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <td><strong>Created At</strong></td>
          <td><strong>Created By</strong></td>
          <td><strong>Type</strong></td>
          <td><strong>Count</strong></td>
          <td><strong>Notes</strong></td>
        </tr>
      </thead>
      <tbody v-if="transactions && transactions.length > 0">
        <tr v-for="(item, index) in transactions" :key="index">
          <td>{{ item.created_at | prettyDate }}</td>
          <td>{{ item.created_by ? item.created_by.full_name : "" }}</td>
          <td>{{ item.type ? item.type.name : "" }}</td>
          <td>{{ item.count }}</td>
          <td>{{ item.notes }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr><td colspan="4" class="text-center">No transactions found.</td></tr>
      </tbody>
    </table>
    <div v-if="showPagination" class="left-column">
      <b-pagination v-model="currentPage"
        :total-rows="transactionCount"
        :per-page="perPage"
        @change="fetchTransactions" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TransactionTable',
  props: {
    poolId: String,
    perPage: Number,
    showPagination: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1
    };
  },
  created() {
    this.fetchTransactions();
  },
  methods: {
    async fetchTransactions(page) {
      this.isLoading = true;
      if (page) {
        this.currentPage = page;
      }
      await this.$store.dispatch('licensePool/fetchTransactions', {
        pool_id: this.poolId,
        params: {
          skip: this.skip,
          limit: this.perPage
        }
      });
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters('licensePool', ['transactions', 'transactionCount']),
    skip() {
      return (this.currentPage - 1) * this.perPage;
    }
  }
};
</script>
